import { render, staticRenderFns } from "./WorkClientAddress.vue?vue&type=template&id=1e0fd585&"
import script from "./WorkClientAddress.vue?vue&type=script&lang=js&"
export * from "./WorkClientAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports